module.exports = __webpack_public_path__ + "static/media/FIL.a7bf962c.svg";